export default {
  CALENDAR: require('./resources/calendar.png'),
  CLOCK: require('./resources/clock.png'),
  DIRECTION: require('./resources/directions.png'),
  FLOOR: require('./resources/floor.png'),
  GLOBE: require('./resources/globe.png'),
  GROUP: require('./resources/group.png'),
  INFO: require('./resources/info.png'),
  PHONE_OUTLINE: require('./resources/phone_outline.png'),
  PHONE: require('./resources/phone.png'),
  SHARE: require('./resources/share.png'),
  LEFT_CHEVRON: require('./resources/back.png'),
  PLACE_HOLDER: require('./resources/placeholder.png'),
  UNIVERSE: require('./resources/universes.png'),
  GEOLOC_ON: require('./resources/geoloc-on.png'),
  GEOLOC_OFF: require('./resources/geoloc-off.png'),
  SWAP: require('./resources/arrow-swap.png'),
  ACCESSIBLE: require('./resources/accessible.png'),
  BADGE: require('./resources/badge.png'),
  BIKE: require('./resources/bike.png'),
  BOAT: require('./resources/boat.png'),
  BUS: require('./resources/bus.png'),
  CAR: require('./resources/car.png'),
  ELEVATOR: require('./resources/elevator.png'),
  ESCALATOR: require('./resources/escalator.png'),
  HELICOPTER: require('./resources/helicopter.png'),
  HELMET: require('./resources/safety-helmet.png'),
  PLANE: require('./resources/plane.png'),
  RAILWAY: require('./resources/railway.png'),
  RAIN: require('./resources/rain.png'),
  RAMP: require('./resources/ramp.png'),
  RUN: require('./resources/run.png'),
  SNOW: require('./resources/snow.png'),
  STAIRS: require('./resources/stairs.png'),
  STROLLER: require('./resources/stroller.png'),
  SUBWAY: require('./resources/subway.png'),
  SUN: require('./resources/sun.png'),
  TRANSIT: require('./resources/transit.png'),
  TROLLEY: require('./resources/trolley-2.png'),
  TRUCK: require('./resources/truck.png'),
  WALK: require('./resources/walk.png'),
  COMPASS: require('./resources/compass.png'),
  ARROW_UP: require('./resources/arrow_up.png'),
  ARROW_DOWN: require('./resources/arrow_down.png'),
  DIRECTION_START: require('./resources/depart.png'),
  DIRECTION_END: require('./resources/arrivee.png'),
}
